/**
 * @file: ReportSharedBody.tsx
 *
 * `OrgReportShared` — a coworker shared a report via one of the
 * supported share methods. One-glance "who / what / how / to-whom"
 * line (the thread is already scoped to one order, so the order-no
 * would be redundant noise). The share target (车主 / 服务专员) only
 * shows when the producer knows it — legacy rows leave it unset.
 */

import { OrgReportSharedFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import {
  reportTypeName,
  shareMethodName,
  shareTargetName,
} from './common/labels';
import { KeyValueGrid, TitleText } from './common/primitives';

export const ReportSharedBody: FC<{ p: OrgReportSharedFeedPayload }> = ({
  p,
}) => (
  <View>
    <TitleText>
      {p.sharedByName ?? '同事'} 分享了{reportTypeName(p.reportType)}
    </TitleText>
    <KeyValueGrid
      items={[
        ['分享方式', shareMethodName(p.shareMethod)],
        ...(p.shareTarget != null
          ? [['分享对象', shareTargetName(p.shareTarget)] as [string, string]]
          : []),
      ]}
    />
  </View>
);
